import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment'

const CustomTerminal = (props) => {
    const [output, setOutput] = useState([]);
    const inputRef = useRef(null);

    const [commandHistory, setCommandHistory] = useState([]);
    const [historyIndex, setHistoryIndex] = useState(-1);
    const [isNavigatingHistory, setIsNavigatingHistory] = useState(false);

    useEffect(() => {
        if (isNavigatingHistory && historyIndex !== -1 && inputRef.current) {
            // Establecer un timeout para asegurarse de que el cursor se coloca al final
            setTimeout(() => {
                inputRef.current.setSelectionRange(props.input.length, props.input.length);
            }, 0);
        }
    }, [historyIndex, props.input, isNavigatingHistory]);

    useEffect(() => {
        setOutput([...output, props.linesToPrint])
        props.setLinesToPrint('');
    }, [props.linesToPrint]);

    useEffect(() => {
        window.scrollTo(0, document.body.scrollHeight);
    }, [output]);

    const resolveCommand = (texto) => {
        const palabras = texto.split(' ');
        let comando = palabras[0];

        // Poner comando en Lowercase en caso de que no sea las arrows
        if (!["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(comando)) {
            comando = comando.toLowerCase();
        }

        console.log("RESOLVE COMMAND: ", comando)

        // Obtén el resto de las palabras
        const restoDePalabras = palabras.slice(1);

        // Convierte el resto de palabras en un string nuevamente
        let parametrosComando = restoDePalabras.join(' ');

        // No paso a lowercase el comando hablar.
        if (comando != "login" && comando != "decir" && comando != "d" && comando != "dar" && comando != "retener" && comando != "disparar" && comando != "revisar" && comando != "quitar" && comando != "puerta" && comando != "cofre" && comando != "fabricar" && comando != "rol" && comando != "env" && comando != "susurrar" && comando != "sus" && comando != "generador" && comando != "radio" && comando != "r" && comando != "sintonizar") {
            parametrosComando = parametrosComando.toLowerCase();
        }

        switch (comando) {

            case "c":
            case "comandos":
                setOutput([...output, "--------------------------------------------------------------------------------\n\n" + props.handleCommands.comandos()]);
                props.setInput("");
                break;

            case "decir":
            case "d":
                console.log("PARAMETROS DECIR: ", parametrosComando)
                console.log("DECIR LOG: ", props.handleCommands.decir(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "susurrar":
            case "sus":
                console.log("PARAMETROS susurrar: ", parametrosComando)
                console.log("susurrar LOG: ", props.handleCommands.susurrar(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "rol":
                console.log("PARAMETROS rol: ", parametrosComando)
                console.log("rol LOG: ", props.handleCommands.rol(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "env":
                console.log("PARAMETROS env: ", parametrosComando)
                console.log("env LOG: ", props.handleCommands.env(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "comer":
                console.log("COMER LOG: ", props.handleCommands.comer().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;
            case "beber":
                console.log("BEBER LOG: ", props.handleCommands.beber().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "inspeccionar":
            case "inspec":
            case "ins":
            case "i":
                console.log("INSPECCIONAR LOG: ", props.handleCommands.inspeccionar().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "n":
            case "no":
            case "nor":
            case "norte":
                console.log("PARAMETROS IR: ", parametrosComando)
                console.log("IR LOG: ", props.handleCommands.norte().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;
            case "s":
            case "su":
            case "sur":
                console.log("PARAMETROS IR: ", parametrosComando)
                console.log("IR LOG: ", props.handleCommands.sur().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;
            case "e":
            case "es":
            case "est":
            case "este":
                console.log("PARAMETROS IR: ", parametrosComando)
                console.log("IR LOG: ", props.handleCommands.este().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;
            case "o":
            case "oe":
            case "oes":
            case "oeste":
                console.log("PARAMETROS IR: ", parametrosComando)
                console.log("IR LOG: ", props.handleCommands.oeste().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;


            case "agarrar":
            case "ag":
                console.log("IR LOG: ", props.handleCommands.agarrar(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "guar":
            case "guardar":
                console.log("GUARDAR LOG: ", props.handleCommands.guardar().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "dar":
                console.log("DAR LOG: ", props.handleCommands.dar(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "tirar":
                console.log("tirar LOG: ", props.handleCommands.tirar().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "revisar":
                console.log("revisar LOG: ", props.handleCommands.revisar(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "quitar":
                console.log("quitar LOG: ", props.handleCommands.quitar(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "disparar":
                console.log("DISPARAR LOG: ", props.handleCommands.disparar(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "retener":
                console.log("RETENER LOG: ", props.handleCommands.retener(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "liberar":
                console.log("CANCELAR RETENER LOG: ", props.handleCommands.liberar(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "sac":
            case "sacar":
                console.log("SACAR LOG: ", props.handleCommands.sacar(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "inventario":
            case "inv":
                console.log("IR LOG: ", props.handleCommands.inventario().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "m":
            case "mapa":
                console.log("MAPA LOG: ", props.handleCommands.mapa().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + response]);
                }));
                props.setInput("");
                break;

            case "online":
                console.log("online LOG: ", props.handleCommands.online().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "estado":
                console.log("estado LOG: ", props.handleCommands.estado().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "hora":
                console.log("hora LOG: ", props.handleCommands.hora().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "timestamp":
                console.log("timestamp LOG: ", props.handleCommands.timestamp());

                setOutput([...output, props.handleCommands.timestamp() + "\n"]);

                props.setInput("");
                break;

            case "puer":
            case "puerta":
                if (!parametrosComando) {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + props.handleCommands.comandosPuerta()]);
                } else {
                    console.log("puerta LOG: ", props.handleCommands.puerta(parametrosComando).then((response) => {
                        setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                    }));
                }
                props.setInput("");
                break;

            case "fab":
            case "fabricar":
                if (!parametrosComando) {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + props.handleCommands.comandosFabricar()]);
                } else {
                    console.log("fabricar LOG: ", props.handleCommands.fabricar(parametrosComando).then((response) => {
                        setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                    }));
                }
                props.setInput("");
                break;

            case "cofre":
                if (!parametrosComando) {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + props.handleCommands.comandosCofre()]);
                } else {
                    console.log("cofre LOG: ", props.handleCommands.cofre(parametrosComando).then((response) => {
                        setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                    }));
                }
                props.setInput("");
                break;

            case "login":
                console.log("login LOG: ", props.handleCommands.login(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "generador":
            case "gen":
                if (!parametrosComando) {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + props.handleCommands.comandosGenerador()]);
                } else {
                    console.log("generador LOG: ", props.handleCommands.generador(parametrosComando).then((response) => {
                        setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                    }));
                }
                props.setInput("");
                break;

            case "combate":
                setOutput([...output, "--------------------------------------------------------------------------------\n\n" + props.handleCommands.combate()]);
                props.setInput("");
                break;

            case "supervivencia":
            case "sup":
                setOutput([...output, "--------------------------------------------------------------------------------\n\n" + props.handleCommands.supervivencia()]);
                props.setInput("");
                break;

            case "exit":
                console.log("exit LOG: ", props.handleCommands.exit());
                props.setInput("");
                break;

            case "leer":
                console.log("leer LOG: ", props.handleCommands.leer().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                }));
                props.setInput("");
                break;

            case "fumar":
                props.handleCommands.fumar().then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                });
                props.setInput("");
                break;

            case "sintonizar":
                props.handleCommands.sintonizar(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                });
                props.setInput("");
                break;

            case "radio":
            case "r":
                props.handleCommands.radio(parametrosComando).then((response) => {
                    setOutput([...output, "--------------------------------------------------------------------------------\n\n" + getTimestamp() + response]);
                });
                props.setInput("");
                break;

            default:
                setOutput([...output, getTimestamp() + "Comando no encontrado. Escribí -comandos- o -c- para ver los comandos disponibles."]);
                props.setInput("");
                break;

        }


    }

    function resolveOnChange(e) {

        const inputValue = e.target.value;
        const words = inputValue.split(' ');
        const lastWord = words[words.length - 1];

        if (lastWord.length <= 25) {
            props.setInput(inputValue);
        }

    }

    function getTimestamp() {
        console.log("TIMESTAMP ACTIVADO EN SESSIONSTORAGE?", sessionStorage.getItem('timestampActivado'))
        console.log("TIMESTAMP ACTIVADO? ", props.timestampActivado)
        if (!props.timestampActivado) {
            return '';
        }

        // Obtener la hora actual en GMT
        const horaActualGMT = moment.utc();

        // Convertir la hora actual de GMT a GMT-3
        const horaActualGMTMenos3 = horaActualGMT.utcOffset('-03:00');

        // Formatear la hora en GMT-3 como cadena de texto
        const horaFormateadaGMTMenos3 = horaActualGMTMenos3.format('HH:mm:ss'); // Quito ms .SSS

        console.log('Hora actual GMT:', horaActualGMT.format('HH:mm:ss')); // Quito ms .SSS
        console.log('Hora actual GMT-3:', horaFormateadaGMTMenos3);

        return '[' + horaFormateadaGMTMenos3 + '] ';
    }

    return (
        <div>
            <div className="terminal-output">
                {output.map((line, index) => (
                    <div key={index} style={{ display: 'flex', whiteSpace: "pre-wrap" }}><p style={{ fontFamily: 'Ubuntu Mono, monospace', color: "white" }}>{line}</p></div>
                ))}
            </div>
            <div className="terminal-input" style={{ display: 'flex', alignItems: "center" }}>
                <p style={{ fontFamily: 'Ubuntu Mono, monospace', color: "#32CD32", marginRight: 5 }}>{(!props.disabled ? (props.inputLabel + props.id) : "") + " > "} </p>
                <input
                    disabled={props.disabled}
                    ref={inputRef}
                    type="text"
                    value={props.input}
                    autoFocus
                    onChange={resolveOnChange}
                    style={{
                        fontFamily: 'Ubuntu Mono, monospace',
                        backgroundColor: 'black',
                        color: 'white',
                        borderColor: 'transparent',
                        width: '60%',
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'ArrowUp') {
                            // Navegar hacia arriba en el historial
                            if (historyIndex < commandHistory.length - 1) {
                                const newIndex = historyIndex + 1;
                                setHistoryIndex(newIndex);
                                props.setInput(commandHistory[newIndex]);
                                setIsNavigatingHistory(true);
                            }
                            e.preventDefault();
                        } else if (e.key === 'ArrowDown') {
                            // Navegar hacia abajo en el historial
                            if (historyIndex > 0) {
                                const newIndex = historyIndex - 1;
                                setHistoryIndex(newIndex);
                                props.setInput(commandHistory[newIndex]);
                                setIsNavigatingHistory(true);
                            } else if (historyIndex === 0) {
                                setHistoryIndex(-1);
                                props.setInput('');
                            }
                            e.preventDefault();
                        } else if (e.key === 'Enter') {
                            resolveCommand(e.target.value);
                            inputRef.current.focus();

                            // Enviar comando y agregarlo al historial
                            const newCommand = e.target.value;
                            if (newCommand.trim() !== '') {
                                setCommandHistory([newCommand, ...commandHistory]);
                                setHistoryIndex(-1);
                            }
                            e.preventDefault();
                        } else if (e.key === 'Backspace' && e.ctrlKey) {
                            e.preventDefault(); // Prevenir el comportamiento predeterminado de borrar caracteres individualmente

                            // Obtener el valor actual del input
                            const inputValue = props.input;

                            // Encontrar el índice del último espacio en blanco, punto o coma antes del cursor
                            const cursorPosition = e.target.selectionStart;
                            let prevWhitespaceIndex = inputValue.lastIndexOf(' ', cursorPosition - 1);
                            const prevCommaIndex = inputValue.lastIndexOf(',', cursorPosition - 1);
                            const prevDotIndex = inputValue.lastIndexOf('.', cursorPosition - 1);

                            // Elegir el índice más grande de los tres
                            prevWhitespaceIndex = Math.max(prevWhitespaceIndex, prevCommaIndex, prevDotIndex);

                            // Si no hay espacios, comas o puntos antes del cursor, eliminamos desde el inicio
                            if (prevWhitespaceIndex === -1) {
                                prevWhitespaceIndex = 0;
                            } else {
                                // Ajustar para eliminar el espacio, coma o punto
                                prevWhitespaceIndex += 1;
                            }

                            // Extraer la parte del input que queremos mantener
                            const newInputValue =
                                inputValue.substring(0, prevWhitespaceIndex) +
                                inputValue.substring(cursorPosition);

                            // Actualizar el valor del input
                            props.setInput(newInputValue);

                            // Ajustar la posición del cursor
                            setTimeout(() => {
                                e.target.setSelectionRange(prevWhitespaceIndex, prevWhitespaceIndex);
                            }, 0);
                        } else {
                            setIsNavigatingHistory(false);
                        }
                    }}
                    maxLength={300}
                />


            </div>
        </div>
    );
};

export default CustomTerminal;
